import { jsx as t } from "react/jsx-runtime";
import { chakra as r } from "@chakra-ui/react";
import { useDatePickerContext as c, useDatePickerStyle as o } from "../DatePicker.context.es.js";
const m = () => {
  const { data: a } = c(), e = o();
  return /* @__PURE__ */ t(r.div, { __css: e.weekDays, children: a.weekDays.map((s) => /* @__PURE__ */ t(r.span, { __css: e.weekDay, children: s.substring(0, 1) }, s)) });
};
export {
  m as DatePickerWeekDays
};
//# sourceMappingURL=DatePickerWeekDays.es.js.map
